(ns rothko.form2.label.component
  (:require [rothko.form2.component :as form]
            [rothko.form2.validation-message.component :as validation-message]
            [rothko.accessibility.screen-reader-text :as screen-reader-text]))

(defn component
  [{:keys [:appearance ::form/label ::form/name]
    :as field-props}]
  (when label
    [:label.form__label
     {:for name
      :class appearance}
     label
     ;; The below span is for screen readers which require that
     ;; validation messages are 'displayed' (not hidden) in the label
     ;; element
     [screen-reader-text/component
      [validation-message/component field-props]]]))
